import React from "react";
import { PageHeader } from "../components/PageHeader";
import { AirportTransfers } from "../components/AirportTransfers";
import { Services } from "../components/Services";
import { HowItWorks } from "../components/HowItWorks";
import { useLang } from "../context/LanguageContext";

export default function Offers() {
  const { t } = useLang();
  return (
    <div className="bg-white" data-testid="offers-page">
      <PageHeader label={t.airport.overline} title={t.pages.offersTitle} subtitle={t.pages.offersSub} />
      <AirportTransfers />
      <Services />
      <HowItWorks />
    </div>
  );
}
